import TH from './TH';

export default TH;